import React from "react";
import { Link } from "react-router-dom";

const AUSTRALIA_DESTINATIONS = [
  {
    id: "nsw",
    name: "New South Wales",
    count: "120 Experiences",
    img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=600&q=80",
    search: "New South Wales",
  },
  {
    id: "vic",
    name: "Victoria",
    count: "85 Experiences",
    img: "https://images.unsplash.com/photo-1514395462725-fb4566210144?auto=format&fit=crop&w=600&q=80",
    search: "Victoria",
  },
  {
    id: "qld",
    name: "Queensland",
    count: "110 Experiences",
    img: "https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?auto=format&fit=crop&w=600&q=80",
    search: "Queensland",
  },
  {
    id: "wa",
    name: "Western Australia",
    count: "64 Experiences",
    img: "https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?auto=format&fit=crop&w=600&q=80",
    search: "Western Australia",
  },
  {
    id: "sa",
    name: "South Australia",
    count: "48 Experiences",
    img: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?auto=format&fit=crop&w=600&q=80",
    search: "South Australia",
  },
  {
    id: "tas",
    name: "Tasmania",
    count: "36 Experiences",
    img: "https://images.unsplash.com/photo-1508672019048-805c876b67e2?auto=format&fit=crop&w=600&q=80",
    search: "Tasmania",
  },
];

function ExploreAustraliaV1() {
  return (
    <section className="v1-australia-section">
      <div className="v1-australia-inner">
        <div className="v1-australia-header">
          <div>
            <h2 className="v1-australia-title">Explore Australia Experiences</h2>
            <p className="v1-australia-subtitle">
              Discover diverse landscapes and vibrant culture across Australia's states and territories.
            </p>
          </div>

          <Link to="/experiences" className="v1-australia-link">
            <span>See all destinations</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>

        <div className="v1-destinations-grid">
          {AUSTRALIA_DESTINATIONS.map((dest) => (
            <Link
              key={dest.id}
              to={`/experiences?search=${encodeURIComponent(dest.search)}`}
              className="v1-dest-card"
            >
              <img
                src={dest.img}
                alt={dest.name}
                className="v1-dest-img"
                loading="lazy"
              />
              <div className="v1-dest-overlay"></div>
              <div className="v1-dest-content">
                <h3 className="v1-dest-name">{dest.name}</h3>
                <p className="v1-dest-count">{dest.count}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExploreAustraliaV1;
